import { useState, useEffect } from 'react';
import { Email } from '../types/email';
import { EmailService } from '../services/emailService';

export function useEmails(folder: string) {
  const [emails, setEmails] = useState<Email[]>([]);
  const [loading, setLoading] = useState(true);
  const emailService = EmailService.getInstance();

  useEffect(() => {
    const fetchEmails = async () => {
      setLoading(true);
      try {
        const fetchedEmails = await emailService.getEmails(folder);
        setEmails(fetchedEmails);
      } finally {
        setLoading(false);
      }
    };

    fetchEmails();
  }, [folder]);

  const sendEmail = async (email: Omit<Email, 'id' | 'timestamp' | 'folder'>) => {
    await emailService.sendEmail(email);
    setEmails(await emailService.getEmails(folder));
  };

  const moveToFolder = async (emailId: string, newFolder: Email['folder']) => {
    await emailService.moveToFolder(emailId, newFolder);
    setEmails(await emailService.getEmails(folder));
  };

  const toggleStar = async (emailId: string) => {
    await emailService.toggleStar(emailId);
    setEmails(await emailService.getEmails(folder));
  };

  const markAsRead = async (emailId: string) => {
    await emailService.markAsRead(emailId);
    setEmails(await emailService.getEmails(folder));
  };

  const deleteEmail = async (emailId: string) => {
    await emailService.deleteEmail(emailId);
    setEmails(await emailService.getEmails(folder));
  };

  const searchEmails = (term: string) => {
    return emailService.searchEmails(term, folder);
  };

  return {
    emails,
    loading,
    sendEmail,
    moveToFolder,
    toggleStar,
    markAsRead,
    deleteEmail,
    searchEmails
  };
}